import React from 'react';
import { PageIndicator, ScreenContainer, ScreenHeader } from '@components';
import { FindPersonNavigator } from '@navigation/FindPersonNavigator';
import { HStack, Text } from 'native-base';
import { useState } from 'react';



export const FindPersonScreen: React.FC = () => {
  const stepsCount = 2;
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <ScreenContainer
      safeAreaBottom
      header={
        <ScreenHeader
          transparent
          title="FIND VOLUNTEER"
          leftStyle="close"
          titleProps={{ size: 'sm' }}
        />
      }
    >
      <FindPersonNavigator onIndexChange={setCurrentStep} />

      <HStack justifyContent="center" space="4">
        <Text fontWeight="700" color="darkGrey" fontSize="14">
          STEP {currentStep + 1} OF {stepsCount}
        </Text>
        <PageIndicator count={stepsCount} selectedIndex={currentStep} />
      </HStack>
    </ScreenContainer>
  );
};
